<template>
  <router-view/>
</template>

<style>
body{
  padding: 0px;
  margin: 0px;
  font-family: "Inter";
  font-style: normal;
  font-weight: bold;
    background: linear-gradient(blue, yellow);
}

</style>
